<script setup lang="ts">
const { recommendedFirmsList } = defineProps({
  recommendedFirmsList: {
    type: Array,
    required: true,
    default: () => []
  }
})

const { t } = useI18n()
const recommendedEntities = recommendedFirmsList.map(firm => {
  return {
    picture: firm.photo,
    title: firm.name,
    url: `/${t('firm')}/${firm.slug}`,
    experience: '',
    reviewsRating: firm.average_rating,
    about: firm.about
  }
})
</script>
<template>
  <div>
    <RecommendedEntities :recommended-entities-list="recommendedEntities">
      <template #badge>{{ $t('firm') }}</template>
      <template #picture><img src="/images/firm.svg" alt="Firm" class="default-img"></template>
    </RecommendedEntities>
  </div>
</template>